import React from 'react';

import CardContainer from 'react/containers/CardContainer';
import BookExtrasView from "react/views/bookExtras/BookExtrasView";
import { TitleBookJacket } from "react/views/bookJacket/BookJacket";
import { getBookSummary } from "data/BookSummarySelector";
import { getJsonData } from "data/DataStore";

import "react/views/bookExtras/bookContents.less";

const BookSummaryContainer = (props) => {
    let model = getBookSummary(getJsonData());

    const title = model && model.bookTitle;
    const text = model && model.summary;
    const image = model && model.bookJacketUrl;
    const jacket = <div className="image-container"><TitleBookJacket title={title} image={image} /></div>;

    return(
        <CardContainer 
            cardModel={model} 
            component={BookExtrasView}
            cardName="Book Summary"
            image={jacket}
            title={title}
            text={text}
            {...props}
        />
    );
}

export default BookSummaryContainer;



// WEBPACK FOOTER //
// ./src/react/containers/bookSummary/BookSummaryContainer.jsx